import SearchInput from './SearchInput'

interface FilterBarProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  onAddJob?: () => void
  onBulkDelete?: () => void
  onBulkAddToJobs?: () => void
  selectedCount?: number
  searchPlaceholder?: string
  addButtonLabel?: string
  showAddButton?: boolean
  showBulkAddToJobs?: boolean
}

function FilterBar({ 
  searchQuery, 
  onSearchChange, 
  onAddJob, 
  onBulkDelete,
  onBulkAddToJobs,
  selectedCount = 0,
  searchPlaceholder = 'Filter Jobs or Companies',
  addButtonLabel = 'Add a New Job',
  showAddButton = true,
  showBulkAddToJobs = false
}: FilterBarProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex-1 min-w-[200px]">
        <SearchInput
          value={searchQuery}
          onChange={onSearchChange}
          placeholder={searchPlaceholder}
        />
      </div>

      {selectedCount > 0 && showBulkAddToJobs && onBulkAddToJobs && (
        <button 
          onClick={onBulkAddToJobs}
          className="px-4 py-2 bg-brand-primary text-text-inverse rounded-md flex items-center gap-2 text-sm font-medium hover:bg-brand-primary-hover whitespace-nowrap min-h-11"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <span>Start Applying ({selectedCount})</span>
        </button>
      )}

      {selectedCount > 0 && onBulkDelete && !showBulkAddToJobs && (
        <button 
          onClick={onBulkDelete}
          className="px-4 py-2 bg-danger text-text-inverse rounded-md flex items-center gap-2 text-sm font-medium hover:bg-danger-hover whitespace-nowrap min-h-11"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          <span>Delete ({selectedCount})</span>
        </button>
      )}

      {showAddButton && onAddJob && (
        <button 
          onClick={onAddJob}
          className="px-4 py-2 bg-brand-primary text-text-inverse rounded-md flex items-center gap-2 text-sm font-medium hover:bg-brand-primary-hover whitespace-nowrap min-h-11"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          <span>{addButtonLabel}</span>
        </button>
      )}
    </div>
  )
}

export default FilterBar
